import { render } from "./ObjectiveCreationView.vue?vue&type=template&id=2f862855&ts=true"
import script from "./ObjectiveCreationView.vue?vue&type=script&lang=ts"
export * from "./ObjectiveCreationView.vue?vue&type=script&lang=ts"

import "./ObjectiveCreationView.vue?vue&type=style&index=0&id=2f862855&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__